import { FileNumberUtil } from './file-number-util';

export class CaseIdentifier {
    /**
    * This is the "mode" in which the case is being viewed. For example, some CR cases are
    * available in both Civil and Criminal CIPRS. When the "civil view" of this data is to be used,
    * this should be 'CIVIL' even though it's a CR(S) case.
    */
    type: CaseType;
    county: string;
    caseNumber: string;

    constructor(type: CaseType, county: string, caseNumber: string) {
        this.type = type;
        this.county = county;
        this.caseNumber = caseNumber;
    }

    equals(caseIdentifier: CaseIdentifier): boolean {
        if (caseIdentifier === null || caseIdentifier === undefined ) {
            return false;
        }
        return (this.type === caseIdentifier.type)
         && (this.county === caseIdentifier.county)
         && (FileNumberUtil.normalizeCaseNumber(this.caseNumber) ===
            FileNumberUtil.normalizeCaseNumber(caseIdentifier.caseNumber));
    }
}

// TODO: use enum?
export type CaseType = 'CIVIL' | 'CRIMINAL' | 'JUVENILE';



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/case-identifier.ts